formatCommentResponse